import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { create, diffProperty, invalidator, v, w } from '@dojo/framework/core/vdom';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import { publish } from '@holmescorp/pub-sub';
import css from '../css/editor.m.css';
import { EditorToolbar } from './toolbar';
const factory = create({
    theme,
    icache: createICacheMiddleware(),
    diffProperty,
    invalidator
}).properties();
export const Editor = factory(({ middleware: { icache, theme, diffProperty, invalidator }, properties, children }) => {
    const { editorId = 'editor', aria = {}, disabled = false, initialContent, placeholder, tabIndex, classes = [], widgetId } = properties();
    let { content } = properties();
    if (content === undefined) {
        content = icache.get('content');
        const existingInitialContent = icache.get('initialContent');
        if (initialContent !== existingInitialContent) {
            icache.set('content', initialContent);
            icache.set('initialContent', initialContent);
            content = initialContent;
        }
    }
    else {
        diffProperty('content', properties, (current, next) => {
            if (current.content !== next.content) {
                icache.delete('editable');
                invalidator();
            }
        });
    }
    const { root, editorRoot } = theme.classes(css);
    return v('div', Object.assign({ xqa: 'editor', widgetId,
        disabled,
        tabIndex, classes: [...classes, root, theme.variant()] }, formatAriaProperties(aria)), [
        w(EditorToolbar, {}),
        icache.getOrSet('editable', v('div', {
            id: editorId,
            placeholder,
            classes: [editorRoot],
            contentEditable: true,
            role: 'textbox',
            onselectstart: () => {
                const getSelection = () => {
                    const selection = document.getSelection();
                    publish('current:selection', selection && selection.getRangeAt(0));
                    document.removeEventListener('keyup', getSelection);
                    document.removeEventListener('mouseup', getSelection);
                };
                document.addEventListener('keyup', getSelection);
                document.addEventListener('mouseup', getSelection);
            },
            oninput: (event) => {
                const { onContent } = properties();
                event.stopPropagation();
                const content = event.target.innerHTML;
                icache.set('content', content);
                onContent && onContent(content);
            },
            onblur: (event) => {
                const { onContent } = properties();
                event.stopPropagation();
                const content = event.target.innerHTML;
                icache.set('content', content);
                onContent && onContent(content);
            },
            innerHTML: content
        })),
        v('div', {}, children())
    ]);
});
export default Editor;
